import { Component, QueryList, ViewChildren } from '@angular/core';
import { TABLAUSUARIOSAPP, tablaUsuariosApp } from '../../../../shared/data/tables/table-usuarios-app';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { TableService } from '../../../../shared/services/table-usuarios-app';
import { Observable } from 'rxjs';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-usuarios-app',
  templateUrl: './usuarios-app.component.html',
  styleUrls: ['./usuarios-app.component.scss']
})
export class UsuariosAppComponent {

  // Variables for date range
  model: NgbDateStruct;
  date: { year: number; month: number };
  displayMonths = 2;
  navigation = "select";
  showWeekNumbers = false;
  outsideDays = "visible";
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  model2: NgbDateStruct;
  placement = "top";
  
  // Other variables
  public isCollapsed = true;
  public selected = [];
  public searchText: string = '';  // Variable para almacenar el texto de búsqueda
  
  // Table data and service
  public tableItem$: Observable<tablaUsuariosApp[]>;
  public filteredTableItems: tablaUsuariosApp[] = [];  // Lista filtrada
  public total$: Observable<number>;
  
  // Services options
  public servicios = [
    { value: "1", label: "Servicio 1", job: "Developer" },
    { value: "2", label: "Servicio 2", job: "Developer" },
    { value: "3", label: "Servicio 3", job: "Developer" },
  ];
  
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  
  // Constructor to initialize the component
  constructor(
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter, 
    private service: TableService
  ) {
    // Initialize table data and set user data
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(TABLAUSUARIOSAPP); // Set the data for the table
    
    // Initialize date range
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), "d", 10);
  }
  
  ngOnInit() {
    // Initialize the filtered list with all the data
    this.tableItem$.subscribe((data) => {
      this.filteredTableItems = data;
    });
  }
  
  // Method to handle date selection
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }
  
  // Helper methods for date range logic
  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }
  
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }
  
  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }
  
  // Validate the date input
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  // Sort method for the table
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
  
    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }
  
  // Method to delete table data
  deleteData(id: number) {
    this.tableItem$.subscribe((data: any) => {
      data.map((elem: any, i: number) => {
        if (elem.id === id) {
          data.splice(i, 1);
        }
      });
    });
  }

  // Filter the data based on the search text (by name)
  filterByMultipleFields() {
    const searchTerm = this.searchText.toLowerCase();
    this.filteredTableItems = TABLAUSUARIOSAPP.filter(item =>
      item.Fecha.toLowerCase().includes(searchTerm) ||
      item.Password.toLowerCase().includes(searchTerm) ||
      item.Usuarios.toLowerCase().includes(searchTerm) 

    );
  }

  // Method to handle the search input
  onSearch(event: any) {
    this.searchText = event.target.value;
    this.filterByMultipleFields();  // Llamar a la función de filtro cuando el texto de búsqueda cambia
  }
}
